module.exports = __webpack_public_path__ + "img/057.577510d2.svg";